var map = {
	"./0.png": "e8ae",
	"./1-1.png": "adb7",
	"./1-2.png": "325a",
	"./10.png": "26fd",
	"./15.png": "f094",
	"./188.png": "74be",
	"./2-1.png": "77e7",
	"./2-2.png": "95eb",
	"./2.png": "7b30",
	"./20.png": "d5bc",
	"./3-1.png": "47c3",
	"./3-2.png": "e3dd",
	"./3.png": "c071",
	"./5.png": "d032",
	"./88.png": "fa32",
	"./ascend_gold1.png": "b6bb",
	"./ascend_gold10.png": "ab83",
	"./ascend_gold11.png": "5c92",
	"./ascend_gold12.png": "934d",
	"./ascend_gold13.png": "b088",
	"./ascend_gold14.png": "c7f2",
	"./ascend_gold15.png": "bc89",
	"./ascend_gold16.png": "16b5",
	"./ascend_gold17.png": "184e",
	"./ascend_gold18.png": "db0a",
	"./ascend_gold19.png": "62f0",
	"./ascend_gold2.png": "60b0",
	"./ascend_gold20.png": "6eaf",
	"./ascend_gold21.png": "ce16",
	"./ascend_gold22.png": "8c36",
	"./ascend_gold28.png": "f6db",
	"./ascend_gold29.png": "8e2e",
	"./ascend_gold3.png": "1cf5",
	"./ascend_gold30.png": "ceda",
	"./ascend_gold31.png": "3241",
	"./ascend_gold32.png": "7bf1",
	"./ascend_gold33.png": "97c6",
	"./ascend_gold34.png": "f3f7",
	"./ascend_gold35.png": "421d",
	"./ascend_gold36.png": "7a52",
	"./ascend_gold37.png": "5426",
	"./ascend_gold38.png": "4215",
	"./ascend_gold39.png": "e916",
	"./ascend_gold40.png": "a19e",
	"./ascend_gold41.png": "8835",
	"./ascend_gold42.png": "7bf4",
	"./ascend_gold43.png": "18c3",
	"./ascend_gold44.png": "0913",
	"./ascend_gold45.png": "6f26",
	"./ascend_gold46.png": "84b7",
	"./ascend_gold47.png": "0994",
	"./ascend_gold48.png": "96d4",
	"./ascend_gold49.png": "cbe6",
	"./ascend_gold5.png": "b50d3",
	"./ascend_gold50.png": "de9a",
	"./ascend_gold6.png": "403d",
	"./ascend_gold8.png": "2aa4",
	"./ascend_gold9.png": "6bcf",
	"./card1.png": "8b69",
	"./card2.png": "6efc",
	"./card3.png": "3645",
	"./demo2.png": "d219",
	"./demo3.png": "81ab",
	"./left1.png": "582e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c40c";